module.exports = __webpack_public_path__ + "media/images/overweightea-0878c4a0023c3a053ca973d68e47aea7.png";